<div class="a">
  <div class="editarAutorizados">
    <h6 translate>inv.authorizedList.title</h6>
    <div  class="btNuevaautorizacion text-right">
      <button  class=" btn btn-primary" translate="" type="button" (click)="onNewAthorizedClicked()"><i  class="fa fa-plus"></i> inv.authorizedList.addAuthorized</button>
    </div>

    <!--   Tabla Autorizados     -->

    <table class="table table-hover table-striped">
      <thead>
      <tr>
        <th scope="col">
          <span class="d-none d-md-block" translate>inv.authorizedList.tableHeaderName</span>
          <span class="d-block d-md-none" translate>inv.authorizedList.tableHeaderNif</span>
        </th>
        <th scope="col" class="d-none d-lg-table-cell"><span translate>inv.authorizedList.tableHeaderType</span></th>
        <th scope="col" class="text-right"><span translate>inv.authorizedList.tableHeaderActions</span></th>
      </tr>
      </thead>
      <tbody>
      <tr class="noResultFound" *ngIf="authorizedList.length == 0">
        <td colspan="3"><span translate>inv.authorizedList.noResults</span></td>
      </tr>

      <tr class="nuevaAutorizacion" *ngIf="swNewAuthorized">
        <td colspan="3">
          <div class="row">
            <div class="col-12 col-md-3 col-sm-4">
              <label translate>inv.authorizedList.typeAuthorizedLabel</label>
              <select [(ngModel)]="type" (change)="errors = null" name="buscadorEstado" class="selectSingularPF custom-select col">
                <option selected></option>
                <option value="Person" translate>inv.authorizedList.typePerson</option>
                <option value="Certificate" translate>inv.authorizedList.typeCertificate</option>
              </select>
            </div>
            <div *ngIf="type === 'Person'" class="col-12 col-md-3 col-sm-4">
              <label>NIF</label>
              <input [(ngModel)]="authorizedPerson.authorizedPerson.identifier" type="text" placeholder="Introduce un nif válido" class="col">

              <div class="notaPie col ml-0">

                <div *ngIf="errors && errors.errors && errors.errors.length > 0">
                  <span *ngFor="let error of errors.errors">{{ error }}</span>
                </div>
                <span *ngIf="errors && errors.authorizedPerson">{{ errors.authorizedPerson.identifier }}</span>
              </div>

            </div>
            <div *ngIf="type === 'Certificate'" class="col-12 col-md-3 col-sm-4">
              <label translate>inv.authorizedList.typeCertificateLabel</label>
              <div class="custom-file">
                <span class="custom-file-label truncate" *ngIf="isFileLoaded">{{authorizedCert.certificate.issuer}}<i class="fa fa-file-o"></i></span>
                <span class="custom-file-label" *ngIf="!isFileLoaded">Seleccione un fichero<i class="fa fa-file-o"></i></span>
                <input type="file" class="custom-file-input" id="inputGroupFile01" (change)="uploadFile($event)">
              </div>
              <div class="notaPie col ml-0">
                <div *ngIf="errors && errors.errors && errors.errors.length > 0">
                  <span *ngFor="let error of errors.errors">{{ error }}</span>
                </div>
              </div>
            </div>
            <div class="col botonera">
              <div>
                <button title="" class="" (click)="cancelInvoicingService()"><i  class="fa fa-times"> <span  class="d-none d-lg-inline-block" translate>inv.authorizedList.cancelCmp</span></i></button>
                <button title="" [disabled]="type !== 'Certificate' && type !== 'Person'" (click)="onSaveAuthorizedsClicked()" translate><i  class="fa fa-check"> <span  class="d-none d-lg-inline-block" translate>inv.authorizedList.saveCmp</span></i>
                </button>
              </div>
            </div>
          </div>
        </td>
      </tr>

      <tr *ngFor="let auth of authorizedList; let i=index">
        <td *ngIf="auth['authorizedPerson']">{{auth.authorizedPerson.identifier}} {{auth.authorizedPerson.name}} {{auth.authorizedPerson.surname1}} {{auth.authorizedPerson.surname2}}</td>
        <td *ngIf="auth['certificate']">{{auth.certificate.issuer}} - {{auth.certificate.serial}}</td>
        <td *ngIf="auth['authorizedPerson']" translate>inv.authorizedList.typePersonInfo</td>
        <td *ngIf="auth['certificate']" translate>inv.authorizedList.typeCertificateInfo</td>
        <td class="text-right">
          <button title="{{'inv.authorizedList.deleteAuthorizedTitle' | translate}}" (click)="openDeleteAuthorized(auth, i)"><i class="fa fa-trash"></i> <span class="d-none d-md-inline-block" translate>inv.platformList.deletePFbt</span></button>
        </td>
      </tr>
      </tbody>
    </table>

    <!-- Fin tabla Autorizados -->
  </div>
</div>

<!-- MODAL remove autorizado -->
<ng-template #modalDeleteAuthorized let-c="close">
  <div class="modal-header">
    <h5 class="modal-title" translate>inv.authorizedList.deleteAuthorizedTitle</h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="c('cancel')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <span translate>inv.authorizedList.deleteAuthorizedBody</span>
  </div>
  <div class="modal-footer">
    <div class="botonera">
      <button type="button" (click)="c('cancel')" class="btn btn-secondary" translate>inv.authorizedList.deleteAuthorizedBtCancel</button>
      <button type="button" class="btn btn-primary" (click)="c('remove')" translate>inv.authorizedList.deleteAuthorizedBtOK</button>
    </div>
  </div>
</ng-template>




// WEBPACK FOOTER //
// ./src/app/app-manager/invoicing-services/inv-authorized-list/inv-authorized-list.component.html